/* v8 ignore start */
import {LottieLayerType} from "@/lib/lottie/layers/lottieLayerType";
import {LottieVisualLayerModel} from "@/lib/lottie/layers/lottieVisualLayerModel";

export class LottieNullLayerModel extends LottieVisualLayerModel<LottieNullLayerModel.IJson> {}

export namespace LottieNullLayerModel {
  export interface IJson extends LottieVisualLayerModel.IJson {
    /**
     * Layer type
     */
    ty: LottieLayerType.Null;
  }
}
/* v8 ignore stop */
